export default __webpack_public_path__ + "static/media/pc.51a0f808.png";